// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"dr","newscontentBox":"dr"};